import { z } from 'zod';
import { c } from '../../contract';

export const topOnePercentUsersRouter = c.router(
  {
    isUserInTopOnePercent: {
      summary: 'Checks if a user is a superfan',
      method: 'GET',
      path: '/is-top-one-percent',
      responses: {
        200: z.object({
          isTopOnePercent: z.boolean(),
        }),
      },
    },
    updateIsUserInTopOnePercentReader: {
      summary: 'Update top readers info',
      method: 'POST',
      path: '/update-top-users',
      body: z.undefined(),
      responses: {
        200: z.object({
          success: z.boolean(),
        }),
      },
    },
  },
  { pathPrefix: '/top-users' },
);
